import { render, staticRenderFns } from "./comparison-swing.vue?vue&type=template&id=5ea43ed0"
import script from "./comparison-swing.vue?vue&type=script&lang=js"
export * from "./comparison-swing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports